module.exports = __webpack_public_path__ + "static/media/laundry.a8568b22.svg";